import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from '../utils/axiosConfig';
import { getDeviceId } from '../utils/deviceId';

const AuthContext = createContext(null);

const API = '/api';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch (error) {
      console.error('Erro ao buscar usuário:', error);
      // Don't logout on fetchUser error - let interceptor handle it
      if (error.response?.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, senha) => {
    try {
      console.log('[AUTH][LOGIN] Attempting login for:', email);
      
      // Get device ID before login
      const deviceId = await getDeviceId();
      console.log('[AUTH][LOGIN] Device ID:', deviceId.substring(0, 8) + '...');
      
      const response = await axios.post(`${API}/auth/login`, { email, senha, deviceId });
      console.log('[AUTH][LOGIN] Response received:', response.status);
      
      const { token: newToken, usuario } = response.data;
      
      console.log('[AUTH][LOGIN] Token received, saving...');
      localStorage.setItem('token', newToken);
      setToken(newToken);
      setUser(usuario);
      
      console.log('[AUTH][LOGIN] Success! User:', usuario.email);
      return usuario;
    } catch (error) {
      console.error('[AUTH][LOGIN] Error:', error.response?.status, error.message);
      
      // Handle device-specific errors
      const errorDetail = error.response?.data?.detail;
      if (errorDetail === 'DEVICE_NOT_AUTHORIZED') {
        error.deviceError = 'DEVICE_NOT_AUTHORIZED';
        error.message = 'Este dispositivo não está autorizado. Contate o administrador.';
      } else if (errorDetail === 'DEVICE_BLOCKED') {
        error.deviceError = 'DEVICE_BLOCKED';
        error.message = 'Este dispositivo foi bloqueado. Contate o administrador.';
      }
      
      throw error; // Re-throw to be handled by LoginPage
    }
  };

  const register = async (nome, email, senha) => {
    // Get device ID before registration
    const deviceId = await getDeviceId();
    console.log('[AUTH][REGISTER] Device ID:', deviceId.substring(0, 8) + '...');
    
    const response = await axios.post(`${API}/auth/register`, { nome, email, senha, deviceId });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};